import React from 'react'
//import { Box } from '../../shared_components/UI/Box'
//import { Title } from '../Home/parts'
//import styled, { css } from 'styled-components'
//import { MethodBox } from '../PoolDetails/Checkout/styles'
//import { ToggleButton } from '../PoolDetails/Checkout/PaymentMethods'
//import { formatAccountAbbreviation } from '../../shared_components/ConnectedWallet'
import { useSelector } from 'react-redux'
import { selectAccount } from '../../modules/web3/selectors'
//import { ThemedButton } from '../../shared_components/ThemedButton'
//import AnimatedLoader from '../../shared_components/AnimatedLoader'
//import { numberToLocaleString } from '../../utils/numbers'
//import { showDecimalsIfNeeded } from './Allocations/InvestmentInfo'
//
//const Container = styled(Box)`
//  padding: 2rem;
//  ${Title} {
//    text-align: center;
//    margin: auto;
//    margin-bottom: 2rem;
//    text-transform: uppercase;
//  }
//  span.oversub {
//    color: #fff;
//    text-align: center;
//    font-family: 'Space Grotesk';
//    font-size: 24px;
//    font-style: normal;
//    font-weight: 300;
//    line-height: normal;
//  }
//  .fake-table {
//    padding-top: 2rem;
//    span.amount {
//      color: #fff;
//      font-family: 'Space Grotesk';
//      font-size: 22px;
//      font-style: normal;
//      font-weight: 300;
//      line-height: normal;
//      letter-spacing: 0.66px;
//    }
//    span.currency {
//      color: rgba(255, 255, 255, 0.4);
//      font-family: 'Space Grotesk';
//      font-size: 12px;
//      font-style: normal;
//      font-weight: 300;
//      line-height: normal;
//      letter-spacing: 0.36px;
//    }
//    span.currency.bolder {
//      color: #fff;
//      font-family: 'Space Grotesk';
//      font-size: 16px;
//      font-style: normal;
//      font-weight: 300;
//      line-height: normal;
//    }
//    .row {
//      padding: 1.5rem 0;
//      border-bottom: 1px solid rgba(255, 255, 255, 0.15);
//    }
//    .row.no-border {
//      border-bottom: none;
//    }
//    .pb {
//      padding-bottom: 1rem;
//    }
//  }
//  @media (max-width: 1000px) {
//    padding: 1rem 0.5rem;
//  }
//`
//
//const RefundMethodContainer = styled(Box)<{ disabled?: boolean }>`
//  border-radius: 8px;
//  border: 1px solid rgba(255, 255, 255, 0.2);
//  flex-direction: column;
//  background: #030b11;
//  padding: 0.5rem 0rem;
//  ${MethodBox} {
//    margin: 0;
//    width: 100%;
//    max-width: unset;
//  }
//  span.address {
//    color: #fff;
//    font-family: 'Space Grotesk';
//    font-size: 12px;
//    font-style: normal;
//    font-weight: 400;
//    line-height: normal;
//    text-transform: uppercase;
//    opacity: 0.5;
//  }
//  ${({ disabled }) =>
//    disabled &&
//    css`
//      opacity: 0.5;
//      cursor: not-allowed;
//    `}
//`
//
//const PowerByBlast = styled(Box)`
//  color: #fff;
//  font-family: 'Space Grotesk';
//  font-size: 12px;
//  font-style: normal;
//  font-weight: 400;
//  line-height: normal;
//  text-transform: uppercase;
//`

const HowToUseRefund = ({
  claim,
  investmentAmountInUsdb,
  tokensAfterDilution,
  totalRefund,
  isLabs,
  isClaiming,
  isEthRaise,
}: {
  claim: () => void
  investmentAmountInUsdb: number
  tokensAfterDilution: number
  totalRefund: number
  isLabs: boolean
  isClaiming: boolean
  isEthRaise?: boolean
}) => {
  const account = useSelector(selectAccount)
  const currencyToDisplay = isEthRaise ? 'ETH' : 'USDB'
  return null
  //return (
  //  <Container dc g={16}>
  //    <Box dc g={16} c>
  //      <Title>Choose how to use your refund</Title>
  //      <span className="oversub">
  //        This raise was oversubscribed. Choose how to use your refund
  //      </span>
  //    </Box>
  //    <Box c dc g={16}>
  //      <Box className="fake-table" dc>
  //        <strong className="pb">What you paid</strong>
  //        <Box jsb ac className="row">
  //          <Box>
  //            <span>Investment amount</span>
  //          </Box>
  //          <Box ac g={8} fu aw>
  //            <span className="amount">
  //              {showDecimalsIfNeeded(
  //                investmentAmountInUsdb,
  //                isEthRaise ? 5 : 2,
  //              )}
  //            </span>{' '}
  //            <span className="currency">{currencyToDisplay}</span>
  //          </Box>
  //        </Box>
  //        <Box jsb ac className="row">
  //          <Box>
  //            <span>
  //              {currencyToDisplay} Value of your investment after dilution
  //            </span>
  //          </Box>
  //          <Box ac g={8} fu aw>
  //            <span>
  //              {showDecimalsIfNeeded(
  //                investmentAmountInUsdb - totalRefund,
  //                isEthRaise ? 10 : 2,
  //              )}
  //            </span>{' '}
  //          </Box>
  //        </Box>
  //        <Box jsb ac className="row no-border">
  //          <Box>
  //            <span>Total Refund</span>
  //          </Box>
  //          <Box ac g={8} fu aw>
  //            <span className="amount">
  //              {showDecimalsIfNeeded(totalRefund, isEthRaise ? 5 : 2)}
  //            </span>{' '}
  //            <span className="currency bolder">{currencyToDisplay}</span>
  //          </Box>
  //        </Box>
  //      </Box>
  //      <Box dc g={24}>
  //        <strong>Select Refund Method</strong>
  //        <RefundMethodContainer>
  //          <MethodBox>
  //            <Box
  //              align="center"
  //              justify="space-between"
  //              className="mobile-col"
  //            >
  //              <Box align="center" justify="flex-start" flex={1}>
  //                <ToggleButton isActive onClick={() => null} />
  //                <span>To my wallet</span>
  //              </Box>
  //
  //              <Box
  //                justify="flex-end"
  //                align="center"
  //                className="mobile-col mobile-start"
  //              >
  //                <span className="address">
  //                  {formatAccountAbbreviation(account)}
  //                </span>
  //              </Box>
  //            </Box>
  //          </MethodBox>
  //        </RefundMethodContainer>
  //        <RefundMethodContainer disabled>
  //          <MethodBox>
  //            <Box
  //              align="center"
  //              justify="space-between"
  //              className="mobile-col"
  //            >
  //              <Box align="center" flex={1}>
  //                <ToggleButton isActive={false} onClick={() => null} />
  //                <Box ac g={16} className="mobile-col">
  //                  <span>Lock into native yield pool (coming soon)</span>
  //                  <PowerByBlast ac g={8}>
  //                    POWERED BY{' '}
  //                    <img src="/blast-yellow.svg" alt="blast logo" />
  //                  </PowerByBlast>
  //                </Box>
  //              </Box>
  //            </Box>
  //          </MethodBox>
  //          <MethodBox>
  //            <Box
  //              align="center"
  //              justify="space-between"
  //              className="mobile-col"
  //            >
  //              <Box align="center" flex={1} g={16}>
  //                <img src="/chart.svg" alt="chart icon" />
  //                <Box ac g={16}>
  //                  <span>
  //                    Lock your refunded $USDB into ZAPs native yield pool to
  //                    earn 5% APY
  //                  </span>
  //                </Box>
  //              </Box>
  //            </Box>
  //          </MethodBox>
  //          <MethodBox>
  //            <Box
  //              align="center"
  //              justify="space-between"
  //              className="mobile-col"
  //            >
  //              <Box align="center" flex={1} g={16}>
  //                <img src="/seed.svg" alt="chart icon" />
  //                <Box ac g={16}>
  //                  <span>
  //                    Get the option to add these funds to your max allocation
  //                    in the next raise
  //                  </span>
  //                </Box>
  //              </Box>
  //            </Box>
  //          </MethodBox>
  //          <MethodBox>
  //            <Box
  //              align="center"
  //              justify="space-between"
  //              className="mobile-col"
  //            >
  //              <Box align="center" flex={1} g={16}>
  //                <img src="/ticket.svg" alt="chart icon" />
  //                <Box ac g={16}>
  //                  <span>
  //                    Become part of the lottery to receive an estimated 500,000
  //                    $BLAST
  //                  </span>
  //                </Box>
  //              </Box>
  //            </Box>
  //          </MethodBox>
  //        </RefundMethodContainer>
  //      </Box>
  //      <Box marginTop={32} c>
  //        <ThemedButton $styleType="primary" onClick={claim}>
  //          {isClaiming ? (
  //            <AnimatedLoader size={16} />
  //          ) : isLabs ? (
  //            'CLaim Refund to wallet'
  //          ) : (
  //            'Claim Tokens & Refund to wallet'
  //          )}
  //        </ThemedButton>
  //      </Box>
  //    </Box>
  //  </Container>
  //)
}

export default HowToUseRefund
